import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { CreateDeliveryChecklistComponent } from './create-delivery-checklist.component';

const routes: Routes = [
  {
    path: '',
    component: CreateDeliveryChecklistComponent,
    canDeactivate: [DeactivateGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateDeliveryChecklistRoutingModule { }
